import React, { useEffect, useState } from "react";
import styles from "../../../Main.module.css";

import foundationsCoordinates from "../../../utils/data/foundationsCoordinates.json";
import pileCapTypes from "../../../utils/data/pileCapTypes.json";
import solutionHeaders from "../../../utils/data/solutionHeaders.json";
import LicenseTag from "../../../../../components/LicenseTag";

import { pileLengthCalculate } from "../../../utils/services/solutions";

import {
  foundationRegister,
  foundationEdit,
} from "../../../utils/services/solutions";

import {
  Button,
  Select,
  Input,
  Text,
  Table,
  Thead,
  Tr,
  Th,
  Tbody,
  Td,
  Box,
  Editable,
  EditablePreview,
  EditableInput,
  useToast,
  Switch,
  Tooltip,
} from "@chakra-ui/react";
import {
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
} from "@chakra-ui/react";
import { CheckIcon, CloseIcon } from "@chakra-ui/icons";

function FoundationManager({
  userInputs,
  investigationInputs,
  geotechnicsInputs,
  columnGroupInputs,
  columnInputs,
  updateColumnInputs,
  solutionInputs,
  projectData,
  updateProjectData,
  foundationInputs,
  setFoundationInputs,
  pileInputs,
  setPileInputs,
  updateFoundationInputs,
  updatePileInputs,
  formFoundation,
  setFormFoundation,
}) {
  const toast = useToast();
  const [columnOffsetsInputs, setColumnOffsetsInputs] = useState({
    ex: 0,
    ey: 0,
  });

  const [selectedComb, setSelectedComb] = useState("fz_max");
  const [svgContent, setSvgContent] = useState(null);
  const [considerM, setConsiderM] = useState(false);
  const [considerPp, setConsiderPp] = useState(false);

  function updateColumnOffsetsInputs(key, value) {
    if (
      value === "" ||
      value === "-" ||
      value.endsWith(".") ||
      value.endsWith(".0") ||
      value.endsWith("-0")
    ) {
      setColumnOffsetsInputs((prevInputs) => ({
        ...prevInputs,
        [key]: value,
      }));
    } else {
      setColumnOffsetsInputs((prevInputs) => ({
        ...prevInputs,
        [key]: Number(value),
      }));
    }
  }

  function onPileLengthResultsCalculate() {
    if (
      columnInputs["selected_name"] === "N/A" ||
      foundationInputs["l"] === "" ||
      foundationInputs["l"] === "0"
    ) {
      toast({
        title: "Preencha todos os campos",
        status: "warning",
        isClosable: true,
      });
    } else {
      const toastId = toast({
        title: "Calculando...",
        status: "loading",
        duration: null,
      });

      pileLengthCalculate([
        projectData["investigations"][investigationInputs["selected_name"]],
        columnInputs,
        columnOffsetsInputs,
        foundationInputs,
        pileInputs,
      ])
        .then((response) => {
          setSelectedComb("fz_max");
          updateFoundationInputs("rc", response["data"]["rc"]);
          updateFoundationInputs("rc_pile", response["data"]["rc_pile"]);
          updateFoundationInputs("rc_comb", response["data"]["rc_comb"]);
          updateFoundationInputs("rt", response["data"]["rt"]);
          updateFoundationInputs("rt_pile", response["data"]["rt_pile"]);
          updateFoundationInputs("rt_comb", response["data"]["rt_comb"]);

          Object.entries(response["data"]["combs"]).map(
            ([pileName, pileInfo]) => {
              updatePileInputs(pileName, "combs", pileInfo["combs"]);
            }
          );
          if (
            response["data"]["clength"] !== null &&
            response["data"]["tlength"] !== null
          ) {
            updateFoundationInputs("clength", response["data"]["clength"]);
            updateFoundationInputs("tlength", response["data"]["tlength"]);
            let max_length = Math.max(
              response["data"]["clength"],
              response["data"]["tlength"]
            );
            while (
              response["data"]["rc"] >
                projectData["investigations"][
                  investigationInputs["selected_name"]
                ][max_length - 1 - Number(geotechnicsInputs["dimension_3"])][
                  "pa"
                ] ||
              response["data"]["rt"] <
                (-projectData["investigations"][
                  investigationInputs["selected_name"]
                ][max_length - 1 - Number(geotechnicsInputs["dimension_3"])][
                  "rl_accumulated"
                ] *
                  0.7) /
                  2 ||
              max_length ===
                projectData["investigations"][
                  investigationInputs["selected_name"]
                ].length +
                  Number(geotechnicsInputs["dimension_3"])
            ) {
              max_length = max_length + 1;
            }
            updateFoundationInputs("length", max_length);
            updateFoundationInputs(
              "rc_adm",
              projectData["investigations"][
                investigationInputs["selected_name"]
              ][max_length - 1 - Number(geotechnicsInputs["dimension_3"])]["pa"]
            );
            updateFoundationInputs(
              "rt_adm",
              (-projectData["investigations"][
                investigationInputs["selected_name"]
              ][max_length - 1 - Number(geotechnicsInputs["dimension_3"])][
                "rl_accumulated"
              ] *
                0.7) /
                2
            );
            toast({
              title: "Calculado com sucesso",
              status: "success",
              isClosable: true,
            });
          } else {
            let max_length = 0;
            if (
              response["data"]["clength"] !== null &&
              response["data"]["tlength"] === null &&
              response["data"]["clength"] !== 0
            ) {
              updateFoundationInputs("clength", response["data"]["clength"]);
              updateFoundationInputs("tlength", "-");
              max_length = response["data"]["clength"];
            } else if (
              response["data"]["clength"] === null &&
              response["data"]["tlength"] !== null &&
              response["data"]["tlength"] !== 0
            ) {
              updateFoundationInputs("clength", "-");
              updateFoundationInputs("tlength", response["data"]["tlength"]);
              max_length = response["data"]["tlength"];
            } else {
              updateFoundationInputs("clength", "-");
              updateFoundationInputs("tlength", "-");
              max_length = Math.max(
                ...projectData["investigations"][
                  investigationInputs["selected_name"]
                ]
                  .filter(
                    (camada) => camada["pa"] !== "" && camada["pa"] !== "-"
                  )
                  .map(
                    (camada) =>
                      camada["elevation"] +
                      Number(geotechnicsInputs["dimension_3"])
                  )
              );
            }
            updateFoundationInputs("length", max_length);
            updateFoundationInputs(
              "rc_adm",
              projectData["investigations"][
                investigationInputs["selected_name"]
              ][max_length - 1 - Number(geotechnicsInputs["dimension_3"])]["pa"]
            );
            updateFoundationInputs(
              "rt_adm",
              (-projectData["investigations"][
                investigationInputs["selected_name"]
              ][max_length - 1 - Number(geotechnicsInputs["dimension_3"])][
                "rl_accumulated"
              ] *
                0.7) /
                2
            );
            toast({
              title:
                "Carregamento na estaca maior que a sua capacidade de carga",
              status: "warning",
              isClosable: true,
            });
          }
        })
        .catch((error) => {
          toast({
            title: "Erro ao calcular",
            description: "Por favor, tente novamente mais tarde.",
            status: "error",
            isClosable: true,
          });
        })
        .finally(() => {
          toast.close(toastId);
        });
    }
  }

  function onFoundationAction(action) {
    const options = {
      register: async () => {
        if (
          foundationInputs["name"] === "" ||
          foundationInputs["l"] === "" ||
          foundationInputs["clength"] === 0
        ) {
          toast({
            title: "Preencha todos os campos",
            status: "warning",
            isClosable: true,
          });
        } else if (
          projectData["solutions"][solutionInputs["selected_name"]].some(
            (foundation) =>
              foundation["name"] === "B" + foundationInputs["name"] &&
              foundation["column_group"] === columnGroupInputs["selected_name"]
          )
        ) {
          toast({
            title:
              "Uma fundação com esse nome já existe. Escolha um nome diferente",
            status: "error",
            isClosable: true,
          });
        } else {
          const toastId = toast({
            title: "Cadastrando fundação...",
            description: "Aguarde enquanto os dados são processados.",
            status: "loading",
            duration: null,
          });

          try {
            await foundationRegister([
              userInputs["id"],
              investigationInputs["selected_name"],
              geotechnicsInputs,
              columnGroupInputs["selected_name"],
              columnInputs["selected_name"],
              solutionInputs["selected_name"],
              projectData["name"],
              foundationInputs,
              pileInputs,
            ]);
            //Optimistic Update
            const updatedSolutionsData = { ...projectData["solutions"] };
            const updatedFoundationsData = [
              ...projectData["solutions"][solutionInputs["selected_name"]],
            ];
            const parameters = {
              l: foundationInputs["l"],
              quantity: foundationInputs["n"],
              rotate: foundationInputs["rotate"],
              z: foundationInputs["z"],
              weight: foundationInputs["weight"],
              diameter: geotechnicsInputs["dimension_1"],
              rc: foundationInputs["rc"],
              rt: foundationInputs["rt"],
              ca: geotechnicsInputs["dimension_3"],
              length: foundationInputs["length"],
              rc_adm: foundationInputs["rc_adm"],
              rt_adm: foundationInputs["rt_adm"],
            };
            updatedFoundationsData.push({
              name: "B" + foundationInputs["name"],
              parameters: parameters,
              combs: pileInputs,
              column: columnInputs["selected_name"],
              investigation: investigationInputs["selected_name"],
              column_group: columnGroupInputs["selected_name"],
            });
            updatedSolutionsData[solutionInputs["selected_name"]] =
              updatedFoundationsData;
            updateProjectData("solutions", updatedSolutionsData);
            setFormFoundation("");
            setFoundationInputs({
              selected_name: "",
              name: "",
              l: 90,
              n: "1",
              rotate: "0",
              z: 0,
              weight: 0,
              rc: 0,
              rc_pile: "",
              rc_comb: "",
              rt: 0,
              rt_pile: "",
              rt_comb: "",
              clength: 0,
              tlength: 0,
              length: 1,
              rc_adm:
                projectData["investigations"][
                  investigationInputs["selected_name"]
                ][0]["pa"],
              rt_adm:
                (-projectData["investigations"][
                  investigationInputs["selected_name"]
                ][0]["rl_accumulated"] *
                  0.7) /
                2,
            });
            setColumnOffsetsInputs({
              ex: 0,
              ey: 0,
            });
            setPileInputs({
              E1: {
                ex: 0,
                ey: 0,
                x: 0,
                y: 0,
                combs: {
                  fz_max: { fz: 0, mx: 0, my: 0 },
                  fz_min: { fz: 0, mx: 0, my: 0 },
                  mx_max: { fz: 0, mx: 0, my: 0 },
                  my_max: { fz: 0, mx: 0, my: 0 },
                },
              },
            });
            toast({
              title: "Fundação cadastrada com sucesso",
              status: "success",
              isClosable: true,
            });
          } catch (error) {
            toast({
              title: "Erro ao cadastrar fundação, tente novamente mais tarde",
              status: "error",
              isClosable: true,
            });
          } finally {
            toast.close(toastId);
          }
        }
      },
      edit: async () => {
        if (foundationInputs["selected_name"] === "") {
          toast({
            title: "Para executar essa função, selecione uma fundação",
            status: "warning",
            isClosable: true,
          });
        } else if (
          columnInputs["selected_name"] === "N/A" ||
          foundationInputs["name"] === "" ||
          foundationInputs["l"] === "" ||
          foundationInputs["clength"] === 0
        ) {
          toast({
            title: "Preencha todos os campos",
            status: "warning",
            isClosable: true,
          });
        } else if (
          "B" + foundationInputs["selected_name"] !==
            "B" + foundationInputs["name"] &&
          projectData["solutions"][solutionInputs["selected_name"]].some(
            (foundation) =>
              foundation["name"] === "B" + foundationInputs["name"]
          )
        ) {
          toast({
            title:
              "Uma fundação com esse nome já existe. Escolha um nome diferente",
            status: "error",
            isClosable: true,
          });
        } else {
          const toastId = toast({
            title: "Editando fundação...",
            description: "Aguarde enquanto os dados são processados.",
            status: "loading",
            duration: null,
          });

          try {
            await foundationEdit([
              userInputs["id"],
              investigationInputs["selected_name"],
              geotechnicsInputs,
              columnGroupInputs["selected_name"],
              columnInputs["selected_name"],
              solutionInputs["selected_name"],
              projectData["name"],
              foundationInputs,
              pileInputs,
            ]);
            //Optimistic Update
            const updatedSolutionsData = { ...projectData["solutions"] };
            const updatedFoundationsData = [
              ...projectData["solutions"][solutionInputs["selected_name"]],
            ];
            updatedFoundationsData.map((foundation, i) => {
              if (
                "B" + foundationInputs["selected_name"] ===
                  foundation["name"] &&
                columnGroupInputs["selected_name"] ===
                  foundation["column_group"]
              ) {
                const parameters = {
                  l: foundationInputs["l"],
                  quantity: foundationInputs["n"],
                  rotate: foundationInputs["rotate"],
                  z: foundationInputs["z"],
                  weight: foundationInputs["weight"],
                  diameter: geotechnicsInputs["dimension_1"],
                  rc: foundationInputs["rc"],
                  rt: foundationInputs["rt"],
                  ca: geotechnicsInputs["dimension_3"],
                  length: foundationInputs["length"],
                  rc_adm: foundationInputs["rc_adm"],
                  rt_adm: foundationInputs["rt_adm"],
                };
                updatedFoundationsData[i] = {
                  name: "B" + foundationInputs["name"],
                  parameters: parameters,
                  combs: pileInputs,
                  column: columnInputs["selected_name"],
                  investigation: investigationInputs["selected_name"],
                  column_group: columnGroupInputs["selected_name"],
                };
              }
            });
            updatedSolutionsData[solutionInputs["selected_name"]] =
              updatedFoundationsData;
            updateProjectData("solutions", updatedSolutionsData);
            setFormFoundation("");
            setFoundationInputs({
              selected_name: "",
              name: "",
              l: 90,
              n: "1",
              rotate: "0",
              z: 0,
              weight: 0,
              rc: 0,
              rc_pile: "",
              rc_comb: "",
              rt: 0,
              rt_pile: "",
              rt_comb: "",
              clength: 0,
              tlength: 0,
              length: 1,
              rc_adm:
                projectData["investigations"][
                  investigationInputs["selected_name"]
                ][0]["pa"],
              rt_adm:
                (-projectData["investigations"][
                  investigationInputs["selected_name"]
                ][0]["rl_accumulated"] *
                  0.7) /
                2,
            });
            setColumnOffsetsInputs({
              ex: 0,
              ey: 0,
            });
            setPileInputs({
              E1: {
                ex: 0,
                ey: 0,
                x: 0,
                y: 0,
                combs: {
                  fz_max: { fz: 0, mx: 0, my: 0 },
                  fz_min: { fz: 0, mx: 0, my: 0 },
                  mx_max: { fz: 0, mx: 0, my: 0 },
                  my_max: { fz: 0, mx: 0, my: 0 },
                },
              },
            });
            toast({
              title: "Fundação editada com sucesso",
              status: "success",
              isClosable: true,
            });
          } catch (error) {
            toast({
              title: "Erro ao editar fundação, tente novamente mais tarde",
              status: "error",
              isClosable: true,
            });
          } finally {
            toast.close(toastId);
          }
        }
      },
    };
    for (const [key, value] of Object.entries(options)) {
      if (action === key) {
        value();
      }
    }
  }

  function drawBuilder(pileCoordinates, pileInputs) {
    return (
      <svg
        width="300"
        height="300"
        viewBox={`${-1.5 * geotechnicsInputs["dimension_1"] - (foundationInputs["l"] * pileCoordinates["width"]) / 2} ${-1.5 * geotechnicsInputs["dimension_1"] - (foundationInputs["l"] * pileCoordinates["height"]) / 2} ${3 * geotechnicsInputs["dimension_1"] + foundationInputs["l"] * pileCoordinates["width"]} ${3 * geotechnicsInputs["dimension_1"] + foundationInputs["l"] * pileCoordinates["height"]}`}
      >
        {/* Estacas */}
        {Object.keys(pileInputs).map((pileName, i) => (
          <React.Fragment key={"pile" + i}>
            <circle
              cx={pileInputs[pileName]["x"]}
              cy={-pileInputs[pileName]["y"]}
              r={geotechnicsInputs["dimension_1"] / 2}
              fill="white"
              stroke="black"
            />
            <text
              x={pileInputs[pileName]["x"]}
              y={
                -pileInputs[pileName]["y"] -
                geotechnicsInputs["dimension_1"] / 2 -
                5
              }
              fontSize="14"
              fontFamily="Arial"
              fill="black"
            >
              {pileName}
            </text>
          </React.Fragment>
        ))}
        {/* Eixos */}
        <line
          x1={
            -((pileCoordinates["width"] * foundationInputs["l"]) / 2) -
            geotechnicsInputs["dimension_1"] * 1.5
          }
          y1={0}
          x2={
            (pileCoordinates["width"] * foundationInputs["l"]) / 2 +
            geotechnicsInputs["dimension_1"] * 1.5
          }
          y2={0}
          stroke="gray"
          strokeWidth={0.5}
        />
        <text
          x={
            (pileCoordinates["width"] * foundationInputs["l"]) / 2 +
            geotechnicsInputs["dimension_1"] * 1.5
          }
          y={-5}
          fontSize="12"
          fontFamily="Arial"
          fill="gray"
          textAnchor="end"
        >
          X
        </text>
        <line
          x1={0}
          y1={
            -((pileCoordinates["height"] * foundationInputs["l"]) / 2) -
            geotechnicsInputs["dimension_1"] * 1.5
          }
          x2={0}
          y2={
            (pileCoordinates["height"] * foundationInputs["l"]) / 2 +
            geotechnicsInputs["dimension_1"] * 1.5
          }
          stroke="gray"
          strokeWidth={0.5}
        />
        <text
          x={5}
          y={
            -((pileCoordinates["height"] * foundationInputs["l"]) / 2) -
            geotechnicsInputs["dimension_1"] * 1.5 +
            10
          }
          fontSize="12"
          fontFamily="Arial"
          fill="gray"
        >
          Y
        </text>
        {/* Pilar */}
        <rect
          x={+columnOffsetsInputs["ex"] - geotechnicsInputs["dimension_1"] / 4}
          y={-columnOffsetsInputs["ey"] - geotechnicsInputs["dimension_1"] / 4}
          width={geotechnicsInputs["dimension_1"] / 2}
          height={geotechnicsInputs["dimension_1"] / 2}
          fill="none"
          stroke="black"
          strokeWidth={2}
        />
        <line
          x1={columnOffsetsInputs["ex"] - geotechnicsInputs["dimension_1"] / 8}
          y1={-columnOffsetsInputs["ey"]}
          x2={columnOffsetsInputs["ex"] + geotechnicsInputs["dimension_1"] / 8}
          y2={-columnOffsetsInputs["ey"]}
          stroke="black"
          strokeWidth={1}
        />
        <line
          x1={columnOffsetsInputs["ex"]}
          y1={-columnOffsetsInputs["ey"] - geotechnicsInputs["dimension_1"] / 8}
          x2={columnOffsetsInputs["ex"]}
          y2={-columnOffsetsInputs["ey"] + geotechnicsInputs["dimension_1"] / 8}
          stroke="black"
          strokeWidth={1}
        />
      </svg>
    );
  }

  useEffect(() => {
    let pileCoordinates = { ...foundationsCoordinates[foundationInputs["n"]] };
    if (foundationInputs["rotate"] !== "0") {
      pileCoordinates = {};
      pileCoordinates["width"] =
        foundationsCoordinates[foundationInputs["n"]]["height"];
      pileCoordinates["height"] =
        foundationsCoordinates[foundationInputs["n"]]["width"];
      pileCoordinates["piles"] = {};
      Object.entries(
        foundationsCoordinates[foundationInputs["n"]]["piles"]
      ).map(([pileName, pile]) => {
        pileCoordinates["piles"][pileName] = {
          x: pile["y"],
          y: pile["x"],
        };
      });
    }
    const updatedPileInputs = { ...pileInputs };
    Object.entries(pileCoordinates["piles"]).map(([pileName, pile], i) => {
      updatedPileInputs[pileName]["x"] =
        pileInputs[pileName]["ex"] + pile["x"] * foundationInputs["l"];
      updatedPileInputs[pileName]["y"] =
        pileInputs[pileName]["ey"] + pile["y"] * foundationInputs["l"];
    });
    setSvgContent(drawBuilder(pileCoordinates, updatedPileInputs));
  }, [
    foundationInputs["l"],
    foundationInputs["n"],
    foundationInputs["rotate"],
    columnOffsetsInputs,
    pileInputs,
  ]);

  useEffect(() => {
    const z = foundationInputs["z"];
    const weight = foundationInputs["weight"];

    setConsiderM(z !== 0);
    setConsiderPp(weight !== 0);
  }, [foundationInputs["z"], foundationInputs["weight"]]);

  return (
    <>
      <Modal
        isOpen={formFoundation !== ""}
        onClose={() => {
          setFormFoundation("");
          setFoundationInputs({
            selected_name: "",
            name: "",
            l: 90,
            n: "1",
            rotate: "0",
            z: 0,
            weight: 0,
            rc: 0,
            rc_pile: "",
            rc_comb: "",
            rt: 0,
            rt_pile: "",
            rt_comb: "",
            clength: 0,
            tlength: 0,
            length: 1,
            rc_adm:
              projectData["investigations"][
                investigationInputs["selected_name"]
              ][0]["pa"],
            rt_adm:
              (-projectData["investigations"][
                investigationInputs["selected_name"]
              ][0]["rl_accumulated"] *
                0.7) /
              2,
          });
          setColumnOffsetsInputs({
            ex: 0,
            ey: 0,
          });
          setPileInputs({
            E1: {
              ex: 0,
              ey: 0,
              x: 0,
              y: 0,
              combs: {
                fz_max: { fz: 0, mx: 0, my: 0 },
                fz_min: { fz: 0, mx: 0, my: 0 },
                mx_max: { fz: 0, mx: 0, my: 0 },
                my_max: { fz: 0, mx: 0, my: 0 },
              },
            },
          });
        }}
        size="3xl"
      >
        <ModalOverlay />
        <ModalContent>
          <ModalHeader fontSize="md">LANÇAMENTO DE FUNDAÇÃO:</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <div className={styles.structureSectionRow}>
              <div className={styles.structureSectionElement}>
                <Text fontSize="md">
                  Pilar:{" "}
                  {formFoundation === "register" &&
                    columnInputs["selected_name"]}
                </Text>
                {formFoundation === "edit" && (
                  <Select
                    name="column"
                    onChange={(ev) => {
                      updateColumnInputs("selected_name", ev.target.value);
                      projectData["columns"][
                        columnGroupInputs["selected_name"]
                      ].map((column, i) => {
                        if (column["name"] === ev.target.value) {
                          updateColumnInputs("fz", column["fz"]);
                          updateColumnInputs("fx", column["fx"]);
                          updateColumnInputs("fy", column["fy"]);
                          updateColumnInputs("mx", column["mx"]);
                          updateColumnInputs("my", column["my"]);
                        }
                      });
                    }}
                    variant="outline"
                    w="75px"
                    size="xs"
                    fontSize="md"
                    value={columnInputs["selected_name"]}
                  >
                    {columnInputs["selected_name"] === "N/A" && (
                      <option key="N/A" value={"N/A"}>
                        {" "}
                        {"N/A"}{" "}
                      </option>
                    )}
                    {projectData["columns"][columnGroupInputs["selected_name"]]
                      .sort((a, b) => {
                        const numA = a.name.match(/\d+/);
                        const numB = b.name.match(/\d+/);
                        return numA - numB;
                      })
                      .map((column, i) => (
                        <option key={i} value={column["name"]}>
                          {" "}
                          {column["name"]}{" "}
                        </option>
                      ))}
                  </Select>
                )}
              </div>
              <div className={styles.structureSectionElement}>
                <Text fontSize="md">ex(cm)=</Text>
                <Input
                  name="ex"
                  onKeyPress={(event) => {
                    const { selectionStart, selectionEnd, value } =
                      event.target;
                    const newValue =
                      value.slice(0, selectionStart) +
                      event.key +
                      value.slice(selectionEnd);
                    if (!/^-?\d*\.?\d{0,2}$/.test(newValue)) {
                      event.preventDefault();
                    }
                  }}
                  onChange={(ev) =>
                    updateColumnOffsetsInputs("ex", ev.target.value)
                  }
                  onBlur={(ev) => {
                    if (
                      ev.target.value === "" ||
                      ev.target.value === "." ||
                      ev.target.value === "-" ||
                      ev.target.value.endsWith("-.") ||
                      ev.target.value.endsWith("-0") ||
                      ev.target.value.endsWith("-0.") ||
                      ev.target.value.endsWith("-.0") ||
                      ev.target.value.endsWith("-0.0")
                    ) {
                      updateColumnOffsetsInputs("ex", "0");
                    } else if (ev.target.value.endsWith(".")) {
                      updateColumnOffsetsInputs(
                        "ex",
                        ev.target.value.slice(0, -1)
                      );
                    } else if (ev.target.value.endsWith(".0")) {
                      updateColumnOffsetsInputs(
                        "ex",
                        ev.target.value.slice(0, -2)
                      );
                    }
                  }}
                  value={columnOffsetsInputs["ex"]}
                  width="65px"
                  size="xs"
                  fontSize="md"
                />
              </div>
              <div className={styles.structureSectionElement}>
                <Text fontSize="md">ey(cm)=</Text>
                <Input
                  name="ey"
                  onKeyPress={(event) => {
                    const { selectionStart, selectionEnd, value } =
                      event.target;
                    const newValue =
                      value.slice(0, selectionStart) +
                      event.key +
                      value.slice(selectionEnd);
                    if (!/^-?\d*\.?\d{0,2}$/.test(newValue)) {
                      event.preventDefault();
                    }
                  }}
                  onChange={(ev) =>
                    updateColumnOffsetsInputs("ey", ev.target.value)
                  }
                  onBlur={(ev) => {
                    if (
                      ev.target.value === "" ||
                      ev.target.value === "." ||
                      ev.target.value === "-" ||
                      ev.target.value.endsWith("-.") ||
                      ev.target.value.endsWith("-0") ||
                      ev.target.value.endsWith("-0.") ||
                      ev.target.value.endsWith("-.0") ||
                      ev.target.value.endsWith("-0.0")
                    ) {
                      updateColumnOffsetsInputs("ey", "0");
                    } else if (ev.target.value.endsWith(".")) {
                      updateColumnOffsetsInputs(
                        "ey",
                        ev.target.value.slice(0, -1)
                      );
                    } else if (ev.target.value.endsWith(".0")) {
                      updateColumnOffsetsInputs(
                        "ey",
                        ev.target.value.slice(0, -2)
                      );
                    }
                  }}
                  value={columnOffsetsInputs["ey"]}
                  width="65px"
                  size="xs"
                  fontSize="md"
                />
              </div>
            </div>
            <div className={styles.structureColumnCombsSection}>
              <Table variant="simple">
                <Thead>
                  <Tr key={"column-offsets-header"}>
                    <Th fontSize="md" key="column-offsets-comb">
                      Comb.
                    </Th>
                    <Th fontSize="md" key="column-offsets-fz">
                      Fz (tf)
                    </Th>
                    <Th fontSize="md" key="column-offsets-fx">
                      Fx (tf)
                    </Th>
                    <Th fontSize="md" key="column-offsets-fy">
                      Fy (tf)
                    </Th>
                    <Th fontSize="md" key="column-offsets-mx">
                      Mx (tf.m)
                    </Th>
                    <Th fontSize="md" key="column-offsets-my">
                      My (tf.m)
                    </Th>
                  </Tr>
                </Thead>
                <Tbody>
                  {Object.entries(columnInputs["combs"]).map(
                    ([combName, comb], i) => (
                      <Tr
                        key={"row-" + combName}
                        sx={{
                          _hover: {
                            td: {
                              color: "var(--text-color) !important",
                            },
                          },
                        }}
                      >
                        <Td key={combName}>
                          <strong>
                            {{
                              fz_max: "Fz,máx",
                              fz_min: "Fz,mín",
                              mx_max: "Mx,máx",
                              my_max: "My,máx",
                            }[combName] || combName}
                          </strong>
                        </Td>
                        {solutionHeaders["columns"]["values"].map(
                          (value, i) =>
                            value !== "name" && (
                              <Td key={combName + value} w="100%">
                                {comb[value]}
                              </Td>
                            )
                        )}
                      </Tr>
                    )
                  )}
                </Tbody>
              </Table>
            </div>
            <div className={styles.structureSectionRow}>
              <div className={styles.structureSectionElement}>
                <Switch
                  isChecked={considerM}
                  onChange={() => {
                    if (considerM) {
                      setConsiderM(false);
                      updateFoundationInputs("z", 0);
                    } else {
                      setConsiderM(true);
                    }
                  }}
                />
                <Text fontSize="md" paddingLeft="10px">
                  Considerar momento proveniente das cargas horizontais
                </Text>
              </div>
              {considerM && (
                <div className={styles.structureSectionElement}>
                  <Text fontSize="md">z(cm)=</Text>
                  <Input
                    name="z"
                    onKeyPress={(event) => {
                      const value = event.target.value;
                      if (!/^\d*\.?\d{0,2}$/.test(value + event.key)) {
                        event.preventDefault();
                      }
                    }}
                    onChange={(ev) =>
                      updateFoundationInputs("z", ev.target.value)
                    }
                    onBlur={(ev) => {
                      if (ev.target.value === "" || ev.target.value === ".") {
                        updateFoundationInputs("z", "0");
                      } else if (ev.target.value.endsWith(".")) {
                        updateFoundationInputs(
                          "z",
                          ev.target.value.slice(0, -1)
                        );
                      } else if (ev.target.value.endsWith(".0")) {
                        updateFoundationInputs(
                          "z",
                          ev.target.value.slice(0, -2)
                        );
                      } else if (ev.target.value.endsWith(".00")) {
                        updateFoundationInputs(
                          "z",
                          ev.target.value.slice(0, -3)
                        );
                      }
                    }}
                    value={foundationInputs["z"]}
                    width="65px"
                    size="xs"
                    fontSize="md"
                  />
                </div>
              )}
            </div>
            <div className={styles.structureSectionRow}>
              <div className={styles.structureSectionElement}>
                <Switch
                  isChecked={considerPp}
                  onChange={() => {
                    if (considerPp) {
                      setConsiderPp(false);
                      updateFoundationInputs("weight", 0);
                    } else {
                      setConsiderPp(true);
                      updateFoundationInputs("weight", "0");
                    }
                  }}
                />
                <Text fontSize="md" paddingLeft="10px">
                  Considerar peso próprio do bloco
                </Text>
              </div>
              {considerPp && (
                <div className={styles.structureSectionElement}>
                  <Text fontSize="md">PP,bloco(tf)=</Text>
                  <Input
                    name="weight"
                    onKeyPress={(event) => {
                      const value = event.target.value;
                      if (!/^\d*\.?\d{0,2}%?$/.test(value + event.key)) {
                        event.preventDefault();
                      }
                    }}
                    onChange={(ev) =>
                      updateFoundationInputs("weight", ev.target.value)
                    }
                    onBlur={(ev) => {
                      if (
                        ev.target.value === "" ||
                        ev.target.value === "." ||
                        ev.target.value === "%" ||
                        ev.target.value === ".%" ||
                        ev.target.value === "0%" ||
                        ev.target.value === "0.%" ||
                        ev.target.value === "0.0%" ||
                        ev.target.value === "0.00%"
                      ) {
                        updateFoundationInputs("weight", "0");
                      } else if (ev.target.value.endsWith(".")) {
                        updateFoundationInputs(
                          "weight",
                          ev.target.value.slice(0, -1)
                        );
                      } else if (ev.target.value.endsWith(".0")) {
                        updateFoundationInputs(
                          "weight",
                          ev.target.value.slice(0, -2)
                        );
                      } else if (ev.target.value.endsWith(".00")) {
                        updateFoundationInputs(
                          "weight",
                          ev.target.value.slice(0, -3)
                        );
                      } else if (ev.target.value.endsWith(".%")) {
                        updateFoundationInputs(
                          "weight",
                          ev.target.value.replace(".%", "%")
                        );
                      } else if (ev.target.value.endsWith(".0%")) {
                        updateFoundationInputs(
                          "weight",
                          ev.target.value.replace(".0%", "%")
                        );
                      } else if (ev.target.value.endsWith(".00%")) {
                        updateFoundationInputs(
                          "weight",
                          ev.target.value.replace(".00%", "%")
                        );
                      }
                    }}
                    value={foundationInputs["weight"]}
                    width="65px"
                    size="xs"
                    fontSize="md"
                  />
                </div>
              )}
            </div>
            <div className={styles.structureDrawSection}>
              <Box width="300" height="300" margin="10px">
                {svgContent}
              </Box>
              <div className={styles.structureColumnCombsSection}>
                <div className={styles.structureSectionRow}>
                  <div className={styles.structureSectionElement}>
                    <Text fontSize="md">L(cm)=</Text>
                    <Input
                      name="l"
                      onKeyPress={(event) => {
                        const value = event.target.value;
                        if (!/^\d*\.?\d{0,2}$/.test(value + event.key)) {
                          event.preventDefault();
                        }
                      }}
                      onChange={(ev) =>
                        updateFoundationInputs("l", ev.target.value)
                      }
                      onBlur={(ev) => {
                        if (ev.target.value === "" || ev.target.value === ".") {
                          updateFoundationInputs("l", "0");
                        } else if (ev.target.value.endsWith(".")) {
                          updateFoundationInputs(
                            "l",
                            ev.target.value.slice(0, -1)
                          );
                        } else if (ev.target.value.endsWith(".0")) {
                          updateFoundationInputs(
                            "l",
                            ev.target.value.slice(0, -2)
                          );
                        } else if (ev.target.value.endsWith(".00")) {
                          updateFoundationInputs(
                            "l",
                            ev.target.value.slice(0, -3)
                          );
                        }
                      }}
                      value={foundationInputs["l"]}
                      width="60px"
                      size="xs"
                      fontSize="md"
                    />
                  </div>
                  <div className={styles.structureSectionElement}>
                    <Text fontSize="md">Nº de estacas=</Text>
                    <Select
                      name="n"
                      onChange={(ev) => {
                        const piles = {};
                        for (
                          let i = 1;
                          i <= parseInt(ev.target.value.match(/^\d+/)?.[0]);
                          i++
                        ) {
                          piles["E" + i] = {
                            ex: 0,
                            ey: 0,
                            x: 0,
                            y: 0,
                            combs: {
                              fz_max: { fz: 0, mx: 0, my: 0 },
                              fz_min: { fz: 0, mx: 0, my: 0 },
                              mx_max: { fz: 0, mx: 0, my: 0 },
                              my_max: { fz: 0, mx: 0, my: 0 },
                            },
                          };
                        }
                        setPileInputs(piles);
                        updateFoundationInputs("n", ev.target.value);
                      }}
                      variant="outline"
                      w="60px"
                      size="xs"
                      fontSize="md"
                      value={foundationInputs["n"]}
                    >
                      {pileCapTypes["pileQuantities"].map((name, i) => (
                        <option key={"pileOption" + i} value={name}>
                          {" "}
                          {name}{" "}
                        </option>
                      ))}
                    </Select>
                  </div>
                </div>
                <div className={styles.structureSectionRow}>
                  <div className={styles.structureSectionElement}>
                    <Text fontSize="md">Rotação=</Text>
                    <Select
                      name="rotate"
                      onChange={(ev) =>
                        updateFoundationInputs("rotate", ev.target.value)
                      }
                      variant="outline"
                      w="70px"
                      size="xs"
                      fontSize="md"
                      value={foundationInputs["rotate"]}
                    >
                      <option key={"pileRotate" + 0} value={0}>
                        0º
                      </option>
                      <option key={"pileRotate" + 1} value={90}>
                        90º
                      </option>
                    </Select>
                  </div>
                  <Tooltip
                    placement="bottom"
                    isDisabled={
                      userInputs["licenses"]["fundars"]["plan"] !== "trial" &&
                      userInputs["licenses"]["fundars"]["plan"] !== "basic"
                    }
                    label={
                      <span>
                        Para usar essa função habilite a licença{" "}
                        <LicenseTag plan="pro" /> ou uma superior
                      </span>
                    }
                  >
                    <Button
                      name="calculate_1"
                      size="sm"
                      isDisabled={
                        userInputs["licenses"]["fundars"]["plan"] === "trial" ||
                        userInputs["licenses"]["fundars"]["plan"] === "basic"
                      }
                      onClick={onPileLengthResultsCalculate}
                    >
                      Calcular Esforços
                    </Button>
                  </Tooltip>
                </div>
                <div className={styles.structurePiles}>
                  <Table variant="simple">
                    <Thead>
                      <Tr key={"pile-header"}>
                        <Th fontSize="md" key="pile-name">
                          Estaca
                        </Th>
                        <Th fontSize="md" key="pile-ex">
                          ex (cm)
                        </Th>
                        <Th fontSize="md" key="pile-ey">
                          ey (cm)
                        </Th>
                        <Th fontSize="md" key="pile-n">
                          N (tf)
                        </Th>
                        <Th fontSize="md" key="pile-mx">
                          Mx (tf.m)
                        </Th>
                        <Th fontSize="md" key="pile-my">
                          My (tf.m)
                        </Th>
                      </Tr>
                    </Thead>
                    <Tbody>
                      {Object.entries(pileInputs).map(
                        ([pileName, pileInfo], i) => (
                          <Tr
                            key={"pile-row" + i}
                            sx={{
                              _hover: {
                                td: {
                                  color: "var(--text-color) !important",
                                },
                              },
                            }}
                          >
                            <Td key={"pile-name" + i}>
                              <strong>{pileName}</strong>
                            </Td>
                            <Td key={"pile-ex" + i} w="100%">
                              <Editable
                                w="100%"
                                h="100%"
                                value={pileInputs[pileName]["ex"].toString()}
                              >
                                <EditablePreview h="100%" />
                                <EditableInput
                                  h="100%"
                                  onKeyPress={(event) => {
                                    const {
                                      selectionStart,
                                      selectionEnd,
                                      value,
                                    } = event.target;
                                    const newValue =
                                      value.slice(0, selectionStart) +
                                      event.key +
                                      value.slice(selectionEnd);
                                    if (!/^-?\d*\.?\d{0,2}$/.test(newValue)) {
                                      event.preventDefault();
                                    }
                                  }}
                                  onChange={(ev) => {
                                    updatePileInputs(
                                      pileName,
                                      "ex",
                                      ev.target.value
                                    );
                                  }}
                                  onBlur={(ev) => {
                                    if (
                                      ev.target.value === "" ||
                                      ev.target.value === "." ||
                                      ev.target.value === "-" ||
                                      ev.target.value.endsWith("-.") ||
                                      ev.target.value.endsWith("-0") ||
                                      ev.target.value.endsWith("-0.") ||
                                      ev.target.value.endsWith("-.0") ||
                                      ev.target.value.endsWith("-0.0")
                                    ) {
                                      updatePileInputs(pileName, "ex", "0");
                                    } else if (ev.target.value.endsWith(".")) {
                                      updatePileInputs(
                                        pileName,
                                        "ex",
                                        ev.target.value.slice(0, -1)
                                      );
                                    } else if (ev.target.value.endsWith(".0")) {
                                      updatePileInputs(
                                        pileName,
                                        "ex",
                                        ev.target.value.slice(0, -2)
                                      );
                                    }
                                  }}
                                />
                              </Editable>
                            </Td>
                            <Td key={"pile-ey" + i} w="100%">
                              <Editable
                                w="100%"
                                h="100%"
                                value={pileInputs[pileName]["ey"].toString()}
                              >
                                <EditablePreview h="100%" />
                                <EditableInput
                                  h="100%"
                                  onKeyPress={(event) => {
                                    const {
                                      selectionStart,
                                      selectionEnd,
                                      value,
                                    } = event.target;
                                    const newValue =
                                      value.slice(0, selectionStart) +
                                      event.key +
                                      value.slice(selectionEnd);
                                    if (!/^-?\d*\.?\d{0,2}$/.test(newValue)) {
                                      event.preventDefault();
                                    }
                                  }}
                                  onChange={(ev) =>
                                    updatePileInputs(
                                      pileName,
                                      "ey",
                                      ev.target.value
                                    )
                                  }
                                  onBlur={(ev) => {
                                    if (
                                      ev.target.value === "" ||
                                      ev.target.value === "." ||
                                      ev.target.value === "-" ||
                                      ev.target.value.endsWith("-.") ||
                                      ev.target.value.endsWith("-0") ||
                                      ev.target.value.endsWith("-0.") ||
                                      ev.target.value.endsWith("-.0") ||
                                      ev.target.value.endsWith("-0.0")
                                    ) {
                                      updatePileInputs(pileName, "ey", "0");
                                    } else if (ev.target.value.endsWith(".")) {
                                      updatePileInputs(
                                        pileName,
                                        "ey",
                                        ev.target.value.slice(0, -1)
                                      );
                                    } else if (ev.target.value.endsWith(".0")) {
                                      updatePileInputs(
                                        pileName,
                                        "ey",
                                        ev.target.value.slice(0, -2)
                                      );
                                    }
                                  }}
                                />
                              </Editable>
                            </Td>
                            <Td key={"pile-n" + i}>
                              <strong>
                                {pileInfo["combs"][selectedComb]["fz"].toFixed(
                                  2
                                )}
                              </strong>
                            </Td>
                            <Td key={"pile-mx" + i}>
                              <strong>
                                {pileInfo["combs"][selectedComb]["mx"].toFixed(
                                  2
                                )}
                              </strong>
                            </Td>
                            <Td key={"pile-my" + i}>
                              <strong>
                                {pileInfo["combs"][selectedComb]["my"].toFixed(
                                  2
                                )}
                              </strong>
                            </Td>
                          </Tr>
                        )
                      )}
                    </Tbody>
                  </Table>
                </div>
                <div className={styles.structureSectionRow}>
                  <div className={styles.structureSectionElement}>
                    <Text fontSize="md">Combinação=</Text>
                    <Select
                      name="combination"
                      onChange={(ev) => setSelectedComb(ev.target.value)}
                      variant="outline"
                      w="100px"
                      size="xs"
                      fontSize="md"
                      value={selectedComb}
                    >
                      <option key={"comb" + 0} value={"fz_max"}>
                        Fz,máx
                      </option>
                      <option key={"comb" + 1} value={"fz_min"}>
                        Fz,mín
                      </option>
                      <option key={"comb" + 2} value={"mx_max"}>
                        Mx,máx
                      </option>
                      <option key={"comb" + 3} value={"my_max"}>
                        My,máx
                      </option>
                    </Select>
                  </div>
                </div>
              </div>
            </div>
            <div className={styles.structureSectionRow}>
              <Text fontSize="md">
                Compressão máxima:{" "}
                {foundationInputs["rc_pile"] !== "" ? (
                  <strong>
                    {foundationInputs["rc"].toFixed(2)} tf (
                    {foundationInputs["rc_pile"]} -{" "}
                    {foundationInputs["rc_comb"]})
                  </strong>
                ) : (
                  <strong>{foundationInputs["rc"].toFixed(2)} tf</strong>
                )}
              </Text>
              <Text fontSize="md">
                Tração máxima:{" "}
                {foundationInputs["rt_pile"] !== "" ? (
                  <strong>
                    {foundationInputs["rt"].toFixed(2)} tf (
                    {foundationInputs["rt_pile"]} -{" "}
                    {foundationInputs["rt_comb"]})
                  </strong>
                ) : (
                  <strong>{foundationInputs["rt"].toFixed(2)} tf</strong>
                )}
              </Text>
            </div>
            <div className={styles.structureSectionRow}>
              <Text fontSize="md">
                Comprimento necessário:{" "}
                <strong>{foundationInputs["clength"]} m</strong>
              </Text>
              <Text fontSize="md">
                Comprimento necessário:{" "}
                <strong>{foundationInputs["tlength"]} m</strong>
              </Text>
            </div>
            <div className={styles.structureSectionRow}>
              <Text fontSize="md">
                Capacidade de carga:{" "}
                <Text
                  as="strong"
                  color={
                    foundationInputs["rc_adm"] < foundationInputs["rc"]
                      ? "red.500"
                      : "green.500"
                  }
                >
                  {foundationInputs["rc_adm"]} tf
                </Text>
              </Text>
              <Text fontSize="md">
                Capacidade de carga:{" "}
                <Text
                  as="strong"
                  color={
                    foundationInputs["rt_adm"] > foundationInputs["rt"]
                      ? "red.500"
                      : "green.500"
                  }
                >
                  {foundationInputs["rt_adm"].toFixed(2)} tf
                </Text>
              </Text>
            </div>
            <div className={styles.structureSectionRow}>
              <div className={styles.structureSectionElement}>
                <Text fontSize="md">Numeração:</Text>
                <Input
                  name="name"
                  onKeyPress={(event) => {
                    if (!/[0-9]/.test(event.key)) {
                      event.preventDefault();
                    }
                  }}
                  onChange={(ev) =>
                    updateFoundationInputs("name", ev.target.value)
                  }
                  value={foundationInputs["name"]}
                  width="50px"
                  size="xs"
                  fontSize="md"
                />
              </div>
              <div className={styles.structureSectionElement}>
                <Text fontSize="md">Adot.(m)=</Text>
                <Select
                  name="length"
                  onChange={(ev) => {
                    updateFoundationInputs("length", ev.target.value);
                    updateFoundationInputs(
                      "rc_adm",
                      projectData["investigations"][
                        investigationInputs["selected_name"]
                      ][
                        ev.target.value -
                          1 -
                          Number(geotechnicsInputs["dimension_3"])
                      ]["pa"]
                    );
                    updateFoundationInputs(
                      "rt_adm",
                      (-projectData["investigations"][
                        investigationInputs["selected_name"]
                      ][
                        ev.target.value -
                          1 -
                          Number(geotechnicsInputs["dimension_3"])
                      ]["rl_accumulated"] *
                        0.7) /
                        2
                    );
                  }}
                  variant="outline"
                  w="70px"
                  size="xs"
                  fontSize="md"
                  value={foundationInputs["length"]}
                >
                  {foundationInputs["length"] === "N/A" && (
                    <option key="N/A" value={"N/A"}>
                      {" "}
                      {"N/A"}{" "}
                    </option>
                  )}
                  {projectData["investigations"][
                    investigationInputs["selected_name"]
                  ].map(
                    (camada, i) =>
                      camada["pa"] !== "" &&
                      camada["pa"] !== "-" && (
                        <option
                          key={
                            camada["elevation"] +
                            Number(geotechnicsInputs["dimension_3"])
                          }
                        >
                          {camada["elevation"] +
                            Number(geotechnicsInputs["dimension_3"])}
                        </option>
                      )
                  )}
                </Select>
              </div>
              {formFoundation === "register" ? (
                <Tooltip
                  placement="bottom"
                  isDisabled={
                    userInputs["licenses"]["fundars"]["plan"] !== "trial" &&
                    userInputs["licenses"]["fundars"]["plan"] !== "basic"
                  }
                  label={
                    <span>
                      Para usar essa função habilite a licença{" "}
                      <LicenseTag plan="pro" /> ou uma superior
                    </span>
                  }
                >
                  <Button
                    name="calculate_2"
                    size="sm"
                    isDisabled={
                      userInputs["licenses"]["fundars"]["plan"] === "trial" ||
                      userInputs["licenses"]["fundars"]["plan"] === "basic"
                    }
                    onClick={() => onFoundationAction("register")}
                  >
                    Lançar Fundação
                  </Button>
                </Tooltip>
              ) : (
                <Button
                  name="calculate_3"
                  size="sm"
                  onClick={() => onFoundationAction("edit")}
                >
                  Editar Fundação
                </Button>
              )}
            </div>
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
}

export default FoundationManager;
